@if (isLoading) {
  <app-load-general [load]="isLoading"></app-load-general>
}
<div class="flex w-full 2xl:w-[95%] gap-4 lg:py-4 m-auto">
  <div
    class="gap-4 flex lg:flex-row! flex-col w-[inherit] justify-between h-[calc(var(--height-full)-80px)]!"
    [ngClass]="{ 'general-box': !mobile, flex: mobile }"
  >
    <div class="flex flex-col gap-3 xl:w-2/3 lg:w-1/2">
      <!-- <div class="px-1 w-full mx-auto flex justify-between items-center">
        <div class="px-1 sm:px-2 flex flex-col gap-1 py:4">
          <div class="text-(--color-text-primary) font-semibold text-2xl"></div>
          <div class="text-(--color-text-primary) text-lg font-light"></div>
        </div>
      </div> -->

      <div class="px-1 w-full mx-auto flex flex-col gap-2">
        <div class="text-general-title px-3">
          Tienes {{ getproductInCarList().length }} articulos en tu carrito
        </div>
        <div class="gap-2 grid grid-cols-1 xl:grid-cols-2 3xl:grid-cols-3 p-2 scrol-general-x">
          @for (card of getproductInCarList(); track card) {
            <app-cart-card [product]="card" class="m-auto"> </app-cart-card>
          }
        </div>
      </div>
    </div>

    <div class="bg-(--M-color-bg) w-2 rounded-4xl lg:flex hidden"></div>

    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-3 w-full">
        <div class="px-1 w-full mx-auto flex justify-between items-center">
          <div class="px-1 sm:px-2 flex flex-col gap-1 py:4">
            <div class="text-(--color-text-primary) font-semibold text-2xl"></div>
            <div class="text-(--color-text-primary) text-lg font-light"></div>
          </div>
        </div>

        <div class="px-1 w-full mx-auto flex-col gap-2 hidden lg:flex!">
          <div class="text-general-title px-3">Tamboen te pueden interesar estos articulos</div>
          <div class="gap-2 grid grid-cols-1 lg:grid-cols-2 3xl:grid-cols-2 p-2 scrol-general-x">
            @for (card of getproductInCarList(); track card) {
              <app-card-product [product]="card" [small]="true" class="m-auto"> </app-card-product>
            }
          </div>
        </div>
        <div class="bg-(--M-color-bg) h-2 rounded-4xl mx-4 lg:flex hidden"></div>
      </div>

      <div class="flex flex-col gap-2 lg:bg-none bg-white rounded-b rounded-4xl sticky top-0 pb-8">
        <div class="flex justify-between px-4 pt-4">
          <div class="text-general-title">Subtotal</div>
          <div class="text-general-title">
            {{ getTotal() | currency: 'USD' : 'symbol' : '1.2-2' }}
          </div>
        </div>

        <button
          (click)="addParamToUrl(['home'], { statusSelected: 0 })"
          class="button-general mx-6"
          matButton="filled"
        >
          Seguir Comprando
        </button>
        <button (click)="goToCheckout()" class="button-general mx-6" matButton="filled">
          Finalizar Pago
        </button>
      </div>
    </div>
  </div>
</div>
